/* @flow */

import type { $WidgetEnvConfiguration } from '../types';
import envLocal from './local.env';
import envDevelopment from './development.env';
import envTest from './test.env';
import envTesting from './testing.env';
import envInt from './int.env';
import envProduction from './production.env';
import envE2etesting from './e2etesting.env';

export function getEnvConfiguration(env: ?string): $WidgetEnvConfiguration {

  /* default envionment = local */
  let config: $WidgetEnvConfiguration = envLocal;

  const envs = [
    envLocal,
    envDevelopment,
    envE2etesting,
    envTest,
    envTesting,
    envInt,
    envProduction
  ];

  if (env) {
    for (let i = 0; i < envs.length; i++) {
      if (env === envs[i].env) {
        config = (envs[i]: $WidgetEnvConfiguration);
        break;
      }
    }
  }
  return config;
}
